import axios from "axios";

export function fetchFilters(params = {}) {
    return axios.get('/lsystem/api/v1/filters', {params: params})
}
